
import ConditionOperator from '../../../common/common/ConditionOperator';

export default function getConditionOperatorForAttribute(attribute) {

    const operatorsByType = {
        'date': [
            ConditionOperator.EQUAL, ConditionOperator.DIFFERENT,
            ConditionOperator.LESS, ConditionOperator.LESS_EQUAL,
            ConditionOperator.GREAT, ConditionOperator.GREAT_EQUAL
        ],
        'string': [
            ConditionOperator.EQUAL, ConditionOperator.LIKE, ConditionOperator.DIFFERENT
        ],
        'float': [
            ConditionOperator.EQUAL, ConditionOperator.DIFFERENT,
            ConditionOperator.LESS, ConditionOperator.LESS_EQUAL,
            ConditionOperator.GREAT, ConditionOperator.GREAT_EQUAL
        ],
        'integer': [
            ConditionOperator.EQUAL, ConditionOperator.DIFFERENT,
            ConditionOperator.LESS, ConditionOperator.LESS_EQUAL,
            ConditionOperator.GREAT, ConditionOperator.GREAT_EQUAL
        ]
    }

    let availableOperators = [];

    if (attribute) {
        let operators = (attribute.values)
            ? [ConditionOperator.EQUAL, ConditionOperator.DIFFERENT]
            : operatorsByType[attribute.type] || [];

        availableOperators = ConditionOperator.getConditionOperators().filter(item => {
            return (operators.indexOf(item.key) !== -1);
        });
    }

    return availableOperators;
}
